// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router",}[chunkId] || chunkId) + "." + {"125": "cf91006d","354": "b478a622","535": "f7552250","883": "166f3012","887": "ec7fd826","951": "45115d40","984": "719f9e30",}[chunkId] + ".js"
}